import { c as r } from "./ghl-ui.es1190.js";
import { queryElement as o } from "./ghl-ui.es1191.js";
function m(s = {}) {
  let t = null;
  const n = {
    c: (...e) => r(n, ...e),
    use: (e, ...l) => e.install(n, ...l),
    find: o,
    context: {},
    config: s,
    get __styleSheet() {
      if (!t) {
        const e = document.createElement("style");
        return document.head.appendChild(e), t = document.styleSheets[document.styleSheets.length - 1], t;
      }
      return t;
    }
  };
  return n;
}
export {
  m as CssRender
};
